import { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table'
import Dropdown from './Dropdown'
import Paging from './Paging';

export default class Content extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 1,
            itemsPerPage: 20,
            items: props.items ?? [],
            filter: item => true,
            filteredItems : props.items ?? []
        };
    }

    async componentDidMount() {
        await this.loadItems();
    }

    async loadItems() {

    }

    setFilter(filter) {
        let filteredItems = this.state.items.filter(filter);
        let pageNumber = Math.min(Math.ceil(filteredItems.length / this.state.itemsPerPage), this.state.pageNumber);
        pageNumber = Math.max(pageNumber, 1);
        this.setState({ 
            pageNumber: pageNumber,
            filter: filter,
            filteredItems: filteredItems
        });

    }

    setPage(pageNumber) {
        this.setState({ pageNumber: pageNumber });
    }
    setItemsPerPage(itemsPerPage) {
        let topItem = (this.state.pageNumber - 1) * this.state.itemsPerPage + 1;
        let pageNumber = Math.ceil(topItem / itemsPerPage);

        this.setState({
            pageNumber: pageNumber,
            itemsPerPage: itemsPerPage
        });
    }
    setItems(items) {
        let filteredItems = items.filter(this.state.filter);
        let pageNumber = Math.min(Math.ceil(filteredItems.length / this.state.itemsPerPage), this.state.pageNumber);
        pageNumber = Math.max(pageNumber, 1);
        this.setState({
            pageNumber: pageNumber,
            items: items,
            filteredItems: filteredItems
        });
    }

    getNav() {
        return <></>;
    }
    getTableHeader() {
        return <></>;
    }
    getRow(item, index) {
        return <tr>{Object.keys(item).map(key => (
            <td className='col-md-1'>{item[key]}</td>
        ))}</tr>;
    }

    getTable() {
        return (
            <Table striped hover>
                <thead>
                    {this.getTableHeader()}
                </thead>
                <tbody>
                    {
                        (() => {
                            let rows = [];
                            let items = this.state.filteredItems.slice(
                                (this.state.pageNumber - 1) * this.state.itemsPerPage, 
                                this.state.pageNumber * this.state.itemsPerPage + 1
                            );
                            let index = 0;
                            for(let key in items) {
                                rows.push(this.getRow(items[key], index++));
                            }
                            return rows;
                        })()
                    }
                </tbody>
            </Table>
        );
    }

    render() {
        return (
            <Container fluid>
                <Row>
                    <Col>
                        {this.getNav()}
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col />
                    <Col md='auto'>
                        <Container>
                            <Row>
                                <Col>
                                    <Dropdown value={this.state.itemsPerPage} values={[20, 50, 100, 200]} setValue={itemsPerPage => this.setItemsPerPage(itemsPerPage)}/>
                                </Col>
                                <Col>
                                <Paging
                                        pageNumber={this.state.pageNumber}
                                        pageRange={2}
                                        pageCount={Math.ceil(this.state.filteredItems.length / this.state.itemsPerPage)}
                                        setPage={pageNumber => this.setPage(pageNumber)}
                                    />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {this.getTable()}
                    </Col>
                </Row>
                <Row>
                    <Col />
                    <Col md="auto">
                    <Paging 
                            pageNumber={this.state.pageNumber}
                            pageRange={2}
                            pageCount={Math.ceil(this.state.filteredItems.length / this.state.itemsPerPage)}
                            setPage={pageNumber => this.setPage(pageNumber)}
                        />
                    </Col>
                </Row>
            </Container>
        );
    }
}